import { render, staticRenderFns } from "./name-placeholder.vue?vue&type=template&id=37c0bd9f&scoped=true&"
import script from "./name-placeholder.vue?vue&type=script&lang=js&"
export * from "./name-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./name-placeholder.vue?vue&type=style&index=0&id=37c0bd9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0bd9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
